exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fs11[data-v-cf69bf3a] {\n  font-size: 11px;\n}\ni[data-v-cf69bf3a] {\n  height: 20px;\n}\n", ""]);

// exports
